// assets/vh-w2.js — WP-P31 CBD-Öl-Wegweiser V2. ES5-IIFE, kein Framework, kein MutationObserver.
// Nur data-vh-w2-* Attribute. Konzept KONZEPT-CBD-OEL-WEGWEISER-2026-09-24.md §3/4/5/6/9.
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  var closest = function (el, s) { return el && el.closest ? el.closest(s) : null; };
  var RM = false; try { RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var SD = false; try { SD = !!(navigator.connection && navigator.connection.saveData); } catch (e) {}
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  var ICONS = {
    moon: '<path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5Z"></path>',
    leaf: '<path d="M11 20A7 7 0 0 1 4 13c0-4 3-8 9-11 1 5 3 7 5 9a7 7 0 0 1-7 9Z"></path><path d="M4 13c4 0 8 2 9 7"></path>',
    sparkle: '<path d="M12 3.2 13.3 8.7 18.8 10 13.3 11.3 12 16.8 10.7 11.3 5.2 10 10.7 8.7 12 3.2Z"></path>',
    sunrise: '<path d="M12 3v5"></path><path d="m5.6 10.6 1.4 1.4"></path><path d="m17 12 1.4-1.4"></path><path d="M3 17h18"></path><path d="M7 17a5 5 0 0 1 10 0"></path>',
    heart: '<path d="M12 20.5S4 15.7 4 9.9A4.4 4.4 0 0 1 12 7a4.4 4.4 0 0 1 8 2.9c0 5.8-8 10.6-8 10.6Z"></path>',
    droplet: '<path d="M12 3s6 7 6 11a6 6 0 0 1-12 0c0-4 6-11 6-11Z"></path>',
    package: '<path d="M12 3 3.5 7.5v9L12 21l8.5-4.5v-9L12 3Z"></path><polyline points="3.5 7.5 12 12 20.5 7.5"></polyline><path d="M12 12v9"></path>',
    shuffle: '<path d="m3 17 5-5-5-5"></path><path d="M8 17h5a4 4 0 0 0 4-4V9a4 4 0 0 1 4-4h0"></path><path d="m21 3-3 3 3 3"></path><path d="m21 21-3-3 3-3"></path>',
    shield: '<path d="M12 3 5 6v5c0 5 3 8.5 7 10 4-1.5 7-5 7-10V6l-7-3Z"></path><path d="m9.5 12 2 2 3.5-4"></path>',
    'arrow-right': '<path d="M4 12h16"></path><path d="m13 5 7 7-7 7"></path>',
    info: '<circle cx="12" cy="12" r="9"></circle><path d="M12 11v6"></path><circle cx="12" cy="7.5" r="1" fill="currentColor" stroke="none"></circle>',
    'check-circle': '<circle cx="12" cy="12" r="9"></circle><path d="m8.5 12.5 2.5 2.5 4.5-5"></path>',
    pfote: '<ellipse cx="12" cy="16.2" rx="5.3" ry="4.3"></ellipse><circle cx="6.3" cy="9.3" r="2"></circle><circle cx="10.4" cy="5.8" r="2"></circle><circle cx="13.9" cy="5.8" r="2"></circle><circle cx="17.9" cy="9.3" r="2"></circle>'
  };
  function ic(n) { return n && ICONS[n] ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + ICONS[n] + '</svg>' : ''; }

  // ---- Copy (WP-P31a-copy.json, Sie-Form) ----
  var VH_W2_FRAGEN = {
    zurueck: 'Zurück', weiter: 'Weiter',
    screens: [
      { id: 'f-anliegen', feld: 'anliegen', typ: 'k', frage: 'Was ist Ihnen gerade wichtig?', optionen: [
        { wert: 'naechte', label: 'Meine Nächte', sub: 'Wie sind Ihre Nächte gerade?', icon: 'moon' },
        { wert: 'ruhe', label: 'Innere Ruhe', sub: 'Begleitet Sie eine innere Unruhe durch den Tag?', icon: 'leaf' },
        { wert: 'konzentration', label: 'Konzentration', sub: 'Wie ist Ihre Konzentration im Laufe des Tages?', icon: 'sparkle' },
        { wert: 'gelenke', label: 'Meine Gelenke', sub: 'Merken Sie Ihre Gelenke beim Treppensteigen oder nach dem Sport?', icon: 'sunrise' },
        { wert: 'alltag', label: 'Mein Alltag', sub: 'Wie geht es Ihnen gerade insgesamt?', icon: 'heart' },
        { wert: 'tier', label: 'Mein Tier', sub: 'Wie geht es Ihrem Tier im Alltag gerade?', icon: 'pfote' }
      ] },
      { id: 'f-form', feld: 'form', typ: 'k', frage: 'Wie möchten Sie es einnehmen?', optionen: [
        { wert: 'tropfen', label: 'Tropfen', sub: 'Mit der Pipette, einfach zu dosieren', icon: 'droplet' },
        { wert: 'kapseln', label: 'Kapseln', sub: 'Feste Menge, super für unterwegs', icon: 'package' },
        { wert: 'egal', label: 'Ist mir egal', sub: 'Zeigen Sie mir beides', icon: 'shuffle' }
      ], traeger: { feld: 'traeger', frage: 'Welcher Geschmack passt zu Ihnen?', optionen: [
        { wert: 'hanf', label: 'Bio-Hanföl', sub: 'nussig, intensiv' },
        { wert: 'mct', label: 'Bio-MCT-Öl', sub: 'mild, neutral' },
        { wert: 'egal', label: 'Ist mir egal', sub: '' }
      ] } },
      { id: 'f-belastung', feld: 'belastung', typ: 's', frage: 'Wie stark beeinträchtigt Sie das gerade im Alltag?',
        mikrotext: 'Warum wir das fragen: So passen wir die Empfehlung an Sie an.', von: 'kaum', bis: 'sehr stark', unberuehrt: 'noch nicht gewählt' },
      { id: 'f-erfahrung', feld: 'erfahrung', typ: 'k', frage: 'Wie viel Erfahrung haben Sie mit CBD?', optionen: [
        { wert: 'neu', label: 'Neu dabei', sub: 'Ich probiere es zum ersten Mal', stufen: [1, 0, 0] },
        { wert: 'etwas', label: 'Schon etwas ausprobiert', sub: 'Ich habe es schon mal genommen', stufen: [1, 1, 0] },
        { wert: 'erfahren', label: 'Ich nehme es schon länger', sub: 'Seit Monaten oder seit Jahren', stufen: [1, 1, 1] }
      ] },
      { id: 'f-einstieg', feld: 'einstieg', typ: 'k', frage: 'Wie möchten Sie starten?', optionen: [
        { wert: 'testen', label: 'Erst mal ausprobieren', sub: 'Lieber mit weniger anfangen', icon: 'shield' },
        { wert: 'direkt', label: 'Gleich mit der passenden Stärke', sub: 'So, wie es aus Ihren Antworten kommt', icon: 'arrow-right' }
      ] }
    ]
  };
  // Review-Fix W3 (25.09., Befund RECHT "Kicker-Bedeutung"): eigene Kicker-Texte je Anliegen fuer
  // den Belastungs-Screen, statt dort das f-anliegen-Label wiederzuverwenden (das ergab bei "ruhe"
  // und "alltag" unsinnige/doppelte Saetze). alltag/tier bleiben leer -> kein Kicker. Das frueher
  // hier deklarierte ANLIEGEN_LABEL diente nur noch diesem Zweck und ist gestrichen (toter Code).
  var ANLIEGEN_KICKER = { naechte: 'Ihre Nächte', ruhe: 'Innere Unruhe', konzentration: 'Ihre Konzentration', gelenke: 'Ihre Gelenke', alltag: '', tier: '' };
  var ERF_LABEL = { neu: 'Neu dabei', etwas: 'Schon etwas ausprobiert', erfahren: 'Ich nehme es schon länger' };
  var C = {
    ergebnisH2: 'Ihre Empfehlung',
    satzE: { neu: 'dass Sie neu dabei sind', etwas: 'dass Sie es schon mal genommen haben', erfahren: 'dass Sie es schon länger nehmen' },
    satzFT: { tropfen_hanf: 'Tropfen in Bio-Hanföl', tropfen_mct: 'Tropfen in Bio-MCT-Öl', tropfen_egal: 'Tropfen', kapseln: 'Kapseln' },
    testenSatz: ' Sie wollten lieber mit weniger anfangen – deshalb eine Stufe niedriger.',
    begrOel: 'Sie haben angegeben, {e} und {ft} möchten. Deshalb schlagen wir {stufe} % CBD in {tr} vor – {rolle}.',
    // Review-Fix W3 (RECHT): eigene, formfreie Begruendung fuer form==='egal' (Nutzer hat NICHT
    // "Tropfen" angegeben, sondern "ist mir egal" -- die alte begrOel-Formel unterstellte das faelschlich).
    begrOelEgal: 'Sie haben angegeben, {e}. Deshalb schlagen wir {stufe} % CBD in {tr} vor – {rolle}.',
    begrKask: 'Sie haben angegeben, {e} und {ft} möchten. Aus Ihren Antworten käme {bstufe} % CBD in {btr}. Das ist gerade nicht lieferbar – hier die nächste Stufe: {nstufe} % CBD in {ntr} – {rolle}.',
    begrKapseln: 'Sie haben Kapseln angegeben. Deshalb schlagen wir {titel} vor – eine Kapsel ist eine feste Menge, ohne Pipette.',
    kickerAlt: 'Oder, wenn Sie möchten:',
    auswahlH2: 'Beide passen – der Unterschied ist der Geschmack',
    // Review-Fix W3 (CODE/MUSS): {kapseln_teil} entkoppelt den Satz von einer falschen 10-%-/5-%-
    // Kapsel-Behauptung -- die Kapseln gibt es nur mit 15 %, der Zusatz erscheint deshalb nur, wenn
    // die gezeigte Stufe tatsaechlich 15 % ist.
    auswahlSatz: 'Sie haben bei der Form „Ist mir egal“ angegeben – deshalb zeigen wir Ihnen die Stufe {stufe} % in beiden Trägerölen{kapseln_teil}.',
    auswahlKapselnTeil: ' und dazu die CBD-Kapseln 15 %',
    ctaOel: 'Alle CBD-Öle ansehen', ctaTier: 'Alle CBD-Produkte für Tiere ansehen', ctaKapseln: 'Alle CBD-Kapseln ansehen',
    verzehr: 'Verzehrempfehlung laut Etikett beachten, angegebene Menge nicht überschreiten.',
    // Review-Fix W3 (RECHT/MUSS): "zusätzlich" strich die implizite Behandlungsaussage (CBD als
    // erste Antwort, Arzt nur als Ergaenzung) -- CLAUDE.md §3.2.
    amber: 'Wenn Sie etwas im Alltag so sehr beeinträchtigt, sprechen Sie bitte mit Ihrer Ärztin oder Ihrem Arzt.',
    kontakt: 'Unsicher? Rufen Sie uns an: +43 660 35 28 248 (Mo–Fr 08:30–16:30) oder schreiben Sie an kundenservice@vitalhemp.de.',
    nochmal: 'Nochmal von vorn', schnellLink: 'Direkt zur Schnellauswahl',
    p1: 'Dieser Wegweiser ersetzt keine ärztliche Diagnose oder Behandlung.',
    p2: 'Nehmen Sie Medikamente ein, sprechen Sie vor der Anwendung mit Ihrer Ärztin oder Ihrem Arzt.',
    p2t: 'Bei gesundheitlichen Anliegen Ihres Tieres sprechen Sie mit Ihrer Tierärztin oder Ihrem Tierarzt.',
    p3: 'Verzehrempfehlung laut Etikett beachten, angegebene Menge nicht überschreiten.',
    fehler: 'Der Wegweiser lädt gerade nicht – die Übersicht unten zeigt Ihnen alle Stärken.',
    hintExpl: '{stufe} % in {tr} ist gerade nicht lieferbar – hier die nächste Stufe.',
    hintAuto: '{stufe} % ist gerade nicht lieferbar – hier die nächste Stufe.',
    hintZwilling: '{stufe} % in {tr} ist gerade nicht lieferbar – hier dieselbe Stärke in {andere}.',
    entfaellt: 'Diese Variante ist gerade nicht lieferbar – in der Übersicht unten finden Sie alle verfügbaren CBD-Öle.'
  };
  function tpl(s, m) { for (var k in m) { if (m.hasOwnProperty(k)) { s = s.split('{' + k + '}').join(m[k]); } } return s; }

  // ---- Empfehlungslogik (Konzept §4) — rein, testbar ----
  var H = {
    p5: 'cbd-oel-5-in-bio-hanfoel', p10: 'cbd-oel-10-in-bio-hanfoel', p15: 'cbd-oel-15-in-bio-hanfoel', p24: 'cbd-oel-24-in-bio-hanfoel',
    a5: 'cbd-oel-5-in-mct-oel', a10: 'cbd-oel-10-in-mct-oel', a15: 'cbd-oel-15-in-mct-oel',
    sleep: 'cbd-cbn-sleep-oel',
    relief: 'cbd-cbg-relief-oel',
    kapseln: 'cbd-kapseln-15-mit-bio-hanfol', pet: 'cbd-oel-pet-lachsoel', vitamin: 'vitamin-d3-k2-in-bio-hanfoel'
  };
  var VH_W2_TRAEGEROEL_DEFAULT = 'auto';
  var VH_W2_BELASTUNG_WIRKT = true;
  var VH_W2_AMBER_STUFE = 10;
  var VH_W2_MATRIX = { neu: { b1: 5, b2: 10, b3: 10 }, etwas: { b1: 5, b2: 10, b3: 15 }, erfahren: { b1: 10, b2: 15, b3: 15 } };
  var MATRIX_OHNE = { neu: 5, etwas: 10, erfahren: 15 };
  var VH_W2_SPERRLISTE = ['schmerzfrei-plus', 'schmerzfrei-plus-bundle', 'schmerzfrei-pdf-guide-inkl-workbook', 'sleep-reset-bundle-1', 'sleep-relief', 'calm-down', 'immun-regeneration', 'mobility-reset-plus-bundle', 'cbd-geschenkset-1', 'cbd-geschenkset-2', 'cbd-geschenkset-3', 'spar-set-ole-probieren-sparen', '15-cbd-ol-in-hanfol-10ml-1-1', 'vitamin-d3-k2-in-bio-hanfol-10-ml-kopie', 'bio-hanftee-mit-kraeuter', 'test-cbd-oel-18-in-bio-hanfoel'];
  var VH_W2_ALT_KASKADE = { sleep: ['kapseln', 'basis_auto'], vitamin: ['kapseln', 'zwilling_haupt'], pure24: ['ast_alt'], kapseln: ['zwilling_haupt', 'nachbarstufe'], nachbarstufe: ['zwilling_nachbarstufe'] };

  function band(b) { return b <= 3 ? 'b1' : (b <= 7 ? 'b2' : 'b3'); }
  function wortB(b) { if (b == null) { return ''; } if (b <= 3) { return 'kaum'; } if (b <= 7) { return 'mittel'; } if (b <= 9) { return 'stark'; } return 'sehr stark'; }
  function gesperrt(h) { return VH_W2_SPERRLISTE.indexOf(h) !== -1; }
  function verf(h, lager) { return !!h && !gesperrt(h) && (h in lagerServer) && lager && lager[h] !== false; }
  function naechsteStufe(s) { return s === 5 ? 10 : (s === 10 ? 15 : (s === 15 ? 10 : 24)); }
  function nachbarKonz(s) { return s === 5 ? 10 : (s === 10 ? 15 : 10); }
  function hh(s) { return 'cbd-oel-' + s + '-in-bio-hanfoel'; }
  function mh(s) { return s === 24 ? null : 'cbd-oel-' + s + '-in-mct-oel'; }
  function stufeVon(h) { var m = /^cbd-oel-(\d+)-in-/.exec(h || ''); return m ? parseInt(m[1], 10) : null; }
  function traegerVon(h) { if (!h) { return null; } return h.indexOf('-in-bio-hanfoel') !== -1 ? 'hanf' : (h.indexOf('-in-mct-oel') !== -1 ? 'mct' : null); }
  function zwilling(h) { var s = stufeVon(h); if (s == null) { return null; } return traegerVon(h) === 'hanf' ? mh(s) : hh(s); }

  function basisStufe(erf, bel, einstieg) {
    // Befund D-Fix 21: defensiv gegen unvollstaendige antworten (z. B. nach einem Sprung ueber
    // popstate) — VH_W2_MATRIX[undefined] wuerde sonst mit TypeError abbrechen.
    var matrixErf = VH_W2_MATRIX[erf] || VH_W2_MATRIX.neu;
    var belWert = bel == null ? 5 : bel;
    var s = VH_W2_BELASTUNG_WIRKT ? matrixErf[band(belWert)] : (MATRIX_OHNE[erf] || MATRIX_OHNE.neu);
    if (einstieg === 'testen') { if (s === 15) { s = 10; } else if (s === 10) { s = 5; } }
    return s;
  }
  function autoTraeger(s, lager) {
    var h1 = hh(s), h2 = mh(s);
    if (verf(h1, lager)) { return { handle: h1, traeger: 'hanf' }; }
    if (verf(h2, lager)) { return { handle: h2, traeger: 'mct' }; }
    return { handle: h1, traeger: 'hanf' };
  }
  // Haupt-Kaskade §4.4 für ein Basis-Öl.
  function resolveOel(stufe, traeger, lager) {
    if (traeger === 'hanf' || traeger === 'mct') {
      var eig = traeger === 'hanf' ? hh(stufe) : mh(stufe);
      if (verf(eig, lager)) { return { handle: eig, traeger: traeger, kaskade: false }; }
      var next = naechsteStufe(stufe), nEig = traeger === 'hanf' ? hh(next) : mh(next);
      if (verf(nEig, lager)) { return { handle: nEig, traeger: traeger, kaskade: true, art: 'explizit', hinweis: tpl(C.hintExpl, { stufe: stufe, tr: traeger === 'hanf' ? 'Bio-Hanföl' : 'Bio-MCT-Öl' }), origStufe: stufe, origTraeger: traeger }; }
      var other = traeger === 'hanf' ? mh(stufe) : hh(stufe);
      if (verf(other, lager)) { return { handle: other, traeger: traeger === 'hanf' ? 'mct' : 'hanf', kaskade: true, art: 'explizit', hinweis: tpl(C.hintZwilling, { stufe: stufe, tr: traeger === 'hanf' ? 'Bio-Hanföl' : 'Bio-MCT-Öl', andere: traeger === 'hanf' ? 'Bio-MCT-Öl' : 'Bio-Hanföl' }), origStufe: stufe, origTraeger: traeger }; }
      return { handle: null, traeger: traeger, kaskade: true, art: 'entfaellt' };
    }
    var pick = autoTraeger(stufe, lager);
    if (verf(pick.handle, lager)) { return { handle: pick.handle, traeger: pick.traeger, kaskade: false }; }
    var na = autoTraeger(naechsteStufe(stufe), lager);
    if (verf(na.handle, lager)) { return { handle: na.handle, traeger: na.traeger, kaskade: true, art: 'auto', hinweis: tpl(C.hintAuto, { stufe: stufe }), origStufe: stufe, origTraeger: 'auto' }; }
    return { handle: null, traeger: pick.traeger, kaskade: true, art: 'entfaellt' };
  }
  function astAlt(anliegen, haupt) {
    if (anliegen === 'ruhe') { return { typ: 'sleep', handle: H.sleep }; }
    if (anliegen === 'konzentration') { var s = stufeVon(haupt.handle), tr = haupt.traeger, nb = nachbarKonz(s); return { typ: 'nachbarstufe', handle: tr === 'mct' ? mh(nb) : hh(nb) }; }
    if (anliegen === 'gelenke') { return { typ: 'kapseln', handle: H.kapseln }; }
    if (anliegen === 'alltag') { return { typ: 'vitamin', handle: H.vitamin }; }
    return { typ: null, handle: null };
  }
  function ersatzFuer(typ, ctx, lager) {
    if (typ === 'kapseln') { return verf(H.kapseln, lager) ? { typ: 'kapseln', handle: H.kapseln } : null; }
    if (typ === 'basis_auto') { var r = resolveOel(ctx.basisStufe || 10, 'auto', lager); return r.handle ? { typ: 'oel', handle: r.handle } : null; }
    if (typ === 'zwilling_haupt') { var z = zwilling(ctx.hauptHandle); return verf(z, lager) ? { typ: 'oel', handle: z } : null; }
    if (typ === 'ast_alt') {
      var std = astAlt(ctx.anliegen, ctx.haupt);
      if (verf(std.handle, lager)) { return std; }
      var kette = VH_W2_ALT_KASKADE[std.typ] || [];
      for (var i = 0; i < kette.length; i++) { var e = ersatzFuer(kette[i], mergeCtx(ctx, { hauptHandle: ctx.hauptHandle, altHandle: std.handle }), lager); if (e) { return e; } }
      return null;
    }
    if (typ === 'nachbarstufe') {
      var s2 = stufeVon(ctx.hauptHandle), tr2 = traegerVon(ctx.hauptHandle), nb2 = naechsteStufe(s2);
      var h2 = tr2 === 'mct' ? mh(nb2) : hh(nb2);
      return verf(h2, lager) ? { typ: 'oel', handle: h2 } : null;
    }
    if (typ === 'zwilling_nachbarstufe') { var zn = zwilling(ctx.altHandle); return verf(zn, lager) ? { typ: 'oel', handle: zn } : null; }
    return null;
  }
  function mergeCtx(a, b) { var o = {}, k; for (k in a) { if (a.hasOwnProperty(k)) { o[k] = a[k]; } } for (k in b) { if (b.hasOwnProperty(k)) { o[k] = b[k]; } } return o; }

  function pruefeAlt(alt, ctx, lager, out) {
    if (!alt || !alt.handle) { return null; }
    if (alt.handle === (out.haupt && out.haupt.handle)) { return null; }
    if (verf(alt.handle, lager)) { return alt; }
    var kette = VH_W2_ALT_KASKADE[alt.typ] || [];
    for (var i = 0; i < kette.length; i++) {
      var e = ersatzFuer(kette[i], ctx, lager);
      if (e && e.handle !== (out.haupt && out.haupt.handle) && verf(e.handle, lager)) { out.kaskade = true; return e; }
    }
    return null;
  }

  // berechne(antworten, lager) -> {typ, haupt, alt, raster, hinweise, amber, kaskade, basisStufe}
  function berechne(antworten, lager) {
    lager = lager || {};
    var a = antworten || {};
    var out = { typ: 'ein_produkt', haupt: null, alt: null, raster: [], hinweise: [], amber: a.belastung === VH_W2_AMBER_STUFE, kaskade: false, basisStufe: null };

    if (a.anliegen === 'tier') { out.typ = 'tier'; out.haupt = { handle: H.pet, familie: 'tier' }; return out; }

    if (a.anliegen === 'naechte') {
      if (a.form === 'kapseln') {
        out.haupt = { handle: H.kapseln, familie: 'kapseln' };
        out.alt = pruefeAlt({ typ: 'sleep', handle: H.sleep }, { anliegen: a.anliegen, hauptHandle: H.kapseln }, lager, out);
        return out;
      }
      if (a.form === 'egal') {
        out.haupt = { handle: H.sleep, familie: 'sleep' };
        out.alt = pruefeAlt({ typ: 'kapseln', handle: H.kapseln }, { anliegen: a.anliegen, hauptHandle: H.sleep }, lager, out);
        return out;
      }
      var bN = basisStufe(a.erfahrung, a.belastung, 'direkt');
      out.basisStufe = bN;
      if (verf(H.sleep, lager)) {
        out.haupt = { handle: H.sleep, familie: 'sleep' };
        var rN = resolveOel(bN, 'auto', lager);
        out.alt = pruefeAlt({ typ: 'oel', handle: rN.handle }, { anliegen: a.anliegen, hauptHandle: H.sleep, basisStufe: bN }, lager, out);
      } else {
        var basisR = resolveOel(bN, 'auto', lager);
        out.haupt = { handle: basisR.handle, familie: 'oel', traeger: basisR.traeger };
        out.kaskade = true;
        if (basisR.hinweis) { out.hinweise.push(basisR.hinweis); }
        out.alt = pruefeAlt({ typ: 'kapseln', handle: H.kapseln }, { anliegen: a.anliegen, hauptHandle: basisR.handle }, lager, out);
      }
      return out;
    }

    var traegerFrage = a.traeger || VH_W2_TRAEGEROEL_DEFAULT;

    if (a.form === 'kapseln') {
      var bK = basisStufe(a.erfahrung, a.belastung, 'direkt');
      out.basisStufe = bK;
      var vR = resolveOel(bK, 'auto', lager);
      out.haupt = { handle: H.kapseln, familie: 'kapseln' };
      if (vR.hinweis) { out.hinweise.push(vR.hinweis); }
      out.kaskade = out.kaskade || vR.kaskade;
      out.alt = pruefeAlt({ typ: 'oel', handle: vR.handle }, { anliegen: a.anliegen, hauptHandle: H.kapseln, basisStufe: bK }, lager, out);
      return out;
    }

    if (a.anliegen === 'gelenke' && verf(H.relief, lager)) {
      // Relief-Öl ist der Gelenke-Ast des Konzepts (§4.4) — gilt auch bei Form "Ist mir egal"
      // (Kapseln-Form ist oben bereits behandelt und returnt vorher). Immer ein_produkt mit
      // Kaufformular, Kapseln als Alt; Befund D-Fix 12/26.
      out.haupt = { handle: H.relief, familie: 'relief' };
      out.alt = pruefeAlt({ typ: 'kapseln', handle: H.kapseln }, { anliegen: a.anliegen, hauptHandle: H.relief }, lager, out);
      return out;
    }

    var bstufe = basisStufe(a.erfahrung, a.belastung, a.einstieg);
    out.basisStufe = bstufe;
    var hauptR = resolveOel(bstufe, traegerFrage, lager);
    out.kaskade = out.kaskade || hauptR.kaskade;
    if (hauptR.hinweis) { out.hinweise.push(hauptR.hinweis); }
    var haupt = { handle: hauptR.handle, familie: 'oel', traeger: hauptR.traeger };
    out.haupt = haupt;

    if (a.form === 'egal') {
      var stA = stufeVon(hauptR.handle) || bstufe;
      // Befund D-Fix 26: Raster nur mit tatsaechlich lieferbaren Oelen fuellen (nicht
      // ungeprueft hh/mh der Stufe uebernehmen) — sonst zeigt das Raster eine ausverkaufte
      // Link-Karte und der Satz "in beiden Traegeroelen" waere falsch.
      var oele = [{ handle: hh(stA) }, { handle: mh(stA) }].filter(function (k) { return verf(k.handle, lager); });
      if (oele.length < 2) {
        var einzelOel = oele[0] || { handle: hauptR.handle };
        out.haupt = { handle: einzelOel.handle, familie: 'oel', traeger: traegerVon(einzelOel.handle) };
        out.alt = pruefeAlt({ typ: 'kapseln', handle: H.kapseln }, { anliegen: a.anliegen, hauptHandle: einzelOel.handle }, lager, out);
        return out;
      }
      out.typ = 'auswahl';
      var raster = oele.concat([{ handle: H.kapseln }]);
      if (a.anliegen === 'alltag') { raster.push({ handle: H.vitamin }); }
      out.raster = raster;
      return out;
    }

    if (hauptR.kaskade && hauptR.art === 'explizit') {
      var zwOrig = hauptR.origTraeger === 'hanf' ? mh(hauptR.origStufe) : hh(hauptR.origStufe);
      out.alt = pruefeAlt({ typ: 'oel', handle: zwOrig }, { anliegen: a.anliegen, hauptHandle: hauptR.handle }, lager, out);
      return out;
    }

    var wB = wortB(a.belastung);
    if (a.erfahrung === 'erfahren' && wB === 'stark' && hauptR.traeger === 'hanf') {
      out.alt = pruefeAlt({ typ: 'pure24', handle: H.p24 }, { anliegen: a.anliegen, haupt: haupt, hauptHandle: haupt.handle, basisStufe: bstufe }, lager, out);
      return out;
    }

    var stdAlt = astAlt(a.anliegen, haupt);
    out.alt = pruefeAlt(stdAlt, { anliegen: a.anliegen, hauptHandle: haupt.handle, basisStufe: bstufe, altHandle: stdAlt.handle }, lager, out);
    return out;
  }

  // ---- Lager-Nachprüfung §4.4 ----
  var lagerCache = {}, lagerServer = {};
  function pruefe_lager(handles, fetchImpl) {
    fetchImpl = fetchImpl || (typeof window !== 'undefined' ? window.fetch : null);
    var eind = [];
    (handles || []).forEach(function (h) { if (h && eind.indexOf(h) === -1) { eind.push(h); } });
    var offen = eind.filter(function (h) { return !(h in lagerCache); });
    if (!offen.length || !fetchImpl) { return Promise.resolve(lagerCache); }
    var jobs = offen.map(function (h) {
      var ctrl = null, sig; try { ctrl = new AbortController(); sig = ctrl.signal; } catch (e) {}
      var t = setTimeout(function () { if (ctrl) { ctrl.abort(); } }, 1500);
      return fetchImpl('/products/' + h + '.js', sig ? { signal: sig } : {})
        .then(function (r) { return r.json(); })
        .then(function (p) { clearTimeout(t); lagerCache[h] = !!p.available; })
        .catch(function () { clearTimeout(t); });
    });
    return Promise.all(jobs).then(function () { return lagerCache; });
  }
  function lagerAktuell() { var o = {}, k; for (k in lagerServer) { if (lagerServer.hasOwnProperty(k)) { o[k] = lagerServer[k]; } } for (k in lagerCache) { if (lagerCache.hasOwnProperty(k)) { o[k] = lagerCache[k]; } } return o; }

  // ---- App-Laufzeit ----
  var app = null, produkte = {}, antworten = {};
  // Review-Fix W3 (SOLL CODE "oeffneSchnellauswahl"): von initSchnellauswahl() gefuellter Handle,
  // damit auch der aeussere "Direkt zur Schnellauswahl"-Link (Ergebnis-Screen) die Schnellauswahl
  // beim Oeffnen aktualisiert -- vorher blieb der Slot dort leer/veraltet.
  var vhW2OeffneSchnell = null;
  function screenEl(id) { return app ? $('[data-vh-w2-screen="' + id + '"]', app) : null; }
  function hatConsent() {
    try { if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function') { return !!window.Shopify.customerPrivacy.analyticsProcessingAllowed(); } } catch (e) {}
    return false;
  }
  function vh_w2_track(ev, payload) {
    if (!hatConsent()) { return; }
    try { window.dataLayer = window.dataLayer || []; var o = { event: ev }; for (var k in payload) { if (payload.hasOwnProperty(k)) { o[k] = payload[k]; } } window.dataLayer.push(o); } catch (e) {}
    try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) { window.Shopify.analytics.publish(ev, payload); } } catch (e) {}
  }

  function stufenHtml(stufen) {
    return stufen.map(function (v) { return '<span data-an="' + (v ? 'true' : 'false') + '"></span>'; }).join('');
  }
  function kachelHtml(o, i) {
    // Runde-3-Fix (C2.2 #6): --i fehlte, der Kachel-Stagger in vh-w2.css lief immer mit --i:0.
    return '<button type="button" class="vh-w2-kachel" role="radio" aria-checked="false" tabindex="' + (i ? '-1' : '0') + '" style="--i:' + i + '" data-wert="' + o.wert + '">' +
      (o.icon ? '<span class="vh-w2-kachel__icon">' + ic(o.icon) + '</span>' : '') +
      (o.stufen ? '<span class="vh-w2-kachel__stufen" aria-hidden="true">' + stufenHtml(o.stufen) + '</span>' : '') +
      '<span class="vh-w2-kachel__label">' + esc(o.label) + '</span>' +
      (o.sub ? '<span class="vh-w2-kachel__sub">' + esc(o.sub) + '</span>' : '') + '</button>';
  }
  function screenHtml(s) {
    var back = s.id === 'f-anliegen' ? '' : '<a href="#" class="vh-w2-zurueck" data-vh-w2-zurueck>' + esc(VH_W2_FRAGEN.zurueck) + '</a>';
    var kicker = s.id === 'f-belastung' ? '<p class="vh-w2-frage__kicker" data-vh-w2-kicker></p>' : '';
    // Review-Fix W3 (SOLL CODE "Bedienelemente ohne Namen"): h2 bekommt eine id, radiogroups und
    // der Slider verweisen per aria-labelledby/-describedby darauf -- vorher lasen Screenreader nur
    // "nicht ausgewaehlt" bzw. den Wert, ohne die Frage selbst.
    var h2Id = 'vh-w2-h-' + s.id;
    var h2 = '<h2 class="vh-w2-frage__h2" id="' + h2Id + '" tabindex="-1">' + esc(s.frage) + '</h2>';
    var body = '';
    if (s.typ === 'k') {
      body = '<div class="vh-w2-kacheln" role="radiogroup" aria-labelledby="' + h2Id + '" data-feld="' + s.feld + '">' + s.optionen.map(kachelHtml).join('') + '</div>';
      if (s.traeger) {
        // Runde-3-Fix (C2.2 #8): .vh-w2-chips__inner ohne Layout-Klasse, Traeger-Chips stapelten
        // block-weise statt im Grid; .vh-w2-kacheln ergaenzt (Vertrag laut vh-w2.css-Kommentar).
        // Review-Fix W3 (SOLL DNA "Traeger-Frage wie ein Versal-Label"): eigene, echte Frage als
        // h3 (statt als 12-px-Versal-Kicker) -- die Traeger-Frage ist eine Frage, kein Meta-Label.
        var h3Id = h2Id + '-tr';
        body += '<div class="vh-w2-chips" data-vh-w2-traeger-block hidden><h3 class="vh-w2-frage__h3" id="' + h3Id + '">' + esc(s.traeger.frage) + '</h3><div class="vh-w2-chips__inner vh-w2-kacheln" role="radiogroup" aria-labelledby="' + h3Id + '" data-feld="traeger">' +
          s.traeger.optionen.map(function (o, oi) {
            return '<button type="button" class="vh-w2-chip vh-chip" role="radio" data-option="traeger" data-value="' + esc(o.label) + '" aria-checked="false" tabindex="' + (oi ? '-1' : '0') + '" data-wert="' + o.wert + '"><span class="vh-chip__t">' + esc(o.label) + '</span>' + (o.sub ? '<span class="vh-chip__s">' + esc(o.sub) + '</span>' : '') + '</button>';
          }).join('') + '</div></div>';
      }
    } else if (s.typ === 's') {
      var mikroId = h2Id + '-mikro';
      body = '<p class="vh-w2-frage__mikro" id="' + mikroId + '">' + esc(s.mikrotext) + '</p>' +
        '<div class="vh-w2-slider vh-w2-slider--unberuehrt"><input type="range" min="1" max="10" step="1" value="5" class="vh-w2-slider__input" data-vh-w2-slider aria-labelledby="' + h2Id + '" aria-describedby="' + mikroId + '" aria-valuetext="' + esc(s.unberuehrt) + '">' +
        '<span class="vh-w2-slider__wort" aria-hidden="true"></span><div class="vh-w2-slider__anker"><span>' + esc(s.von) + '</span><span>' + esc(s.bis) + '</span></div></div>' +
        '<button type="button" class="vh-btn vh-btn--primary vh-btn--auto vh-w2-frage__weiter" data-vh-w2-weiter disabled>' + esc(VH_W2_FRAGEN.weiter) + '</button>';
    }
    // Review-Fix W3 (SOLL DNA "Frage-Screens nicht symmetrisch"): Zurueck hinter den Body setzen
    // (statt davor, ueber Kicker/H2) und dort zentrieren (CSS) -- Konzept §3.1/§6.1.
    return kicker + h2 + body + back;
  }

  function buildScreens() {
    VH_W2_FRAGEN.screens.forEach(function (s) {
      var sec = document.createElement('section');
      sec.className = 'vh-w2-screen vh-w2-frage';
      sec.setAttribute('data-vh-w2-screen', s.id);
      sec.setAttribute('data-vh-reveal', '');
      sec.hidden = true;
      sec.innerHTML = screenHtml(s);
      app.appendChild(sec);
    });
    var ber = document.createElement('section');
    ber.className = 'vh-w2-screen vh-w2-berechnung';
    ber.setAttribute('data-vh-w2-screen', 'berechnung'); ber.hidden = true;
    ber.innerHTML = '<p class="vh-w2-berechnung__text">Wir stellen Ihre Empfehlung zusammen <span class="vh-w2-berechnung__punkte"><span></span><span></span><span></span></span></p>';
    app.appendChild(ber);
    var erg = document.createElement('section');
    erg.id = 'vh-w2-ergebnis';
    erg.className = 'vh-w2-screen vh-w2-ergebnis';
    erg.setAttribute('data-vh-w2-screen', 'ergebnis'); erg.setAttribute('data-vh-reveal', ''); erg.setAttribute('aria-live', 'polite'); erg.hidden = true;
    app.appendChild(erg);
  }

  var verlauf = [];
  var aktuellerScreen = null;
  var gestartet = false; // Befund D-Fix 28: einmal pro Durchlauf, unabhaengig von verlauf.length
  var LEAVE_MS = 400; // > 360ms CSS-Transition der .vh-w2-screen--leave-Klasse (Fallback, falls transitionend nie feuert)
  function schrittNr() { return verlauf.length + 1; }
  function gehe_zu(screen, opts) {
    opts = opts || {};
    var ziel = screenEl(screen);
    // Review-Fix W3 (SOLL CODE "unbekanntes Ziel"): kein Ziel -> nichts tun, statt trotzdem alle
    // sichtbaren Screens auszublenden (liess z. B. nach einem Init-Fehler die einzige statische
    // Alternative verschwinden).
    if (!ziel) { return; }
    // Befund D-Fix 6: erst hidden=false, dann is-in per rAF setzen (unter RM sofort) — sonst
    // berechnet der Browser keinen Startzustand und der Screen springt hart statt einzublenden.
    // Der verlassene Screen bekommt .vh-w2-screen--leave (reiner Opacity-Fade, §6.2) und wird
    // erst nach transitionend/Fallback hidden=true.
    // Review-Fix W3 (MUSS DNA/CODE "Screen-Uebergang schiebt Inhalt"): der verlassene Screen wird
    // waehrend der Leave-Phase per position:absolute aus dem Seitenfluss genommen (Top-Wert =
    // seine bisherige Position, .vh-w2-screen--leave in vh-w2.css traegt position/left/right;
    // #vh-w2-app{position:relative} macht das moeglich) -- sonst stehen beide Screens kurz
    // uebereinander im Fluss und der neue Screen springt, sobald der alte hidden wird.
    $$('.vh-w2-screen', app).forEach(function (el) {
      if (el === ziel) { return; }
      if (!el.hidden) {
        el.classList.remove('is-in');
        if (RM) { el.hidden = true; el.classList.remove('vh-w2-screen--leave'); el.style.top = ''; return; }
        el.style.top = el.offsetTop + 'px';
        el.classList.add('vh-w2-screen--leave');
        var erledigt = false;
        var fertig = function () {
          if (erledigt) { return; }
          erledigt = true;
          // Review-Fix W3 (SOLL CODE "schnelles Zurueck"): wird derselbe Screen innerhalb der
          // Leave-Zeit erneut Ziel (schnelles "Zurueck"/Browser-Zurueck), darf der noch anstehende
          // Timer/transitionend-Callback ihn nicht nachtraeglich wieder verstecken.
          if (el.getAttribute('data-vh-w2-screen') === aktuellerScreen) { el.classList.remove('vh-w2-screen--leave'); el.style.top = ''; return; }
          el.hidden = true;
          el.classList.remove('vh-w2-screen--leave');
          el.style.top = '';
        };
        setTimeout(fertig, LEAVE_MS);
        el.addEventListener('transitionend', function te(ev) { if (ev.target !== el) { return; } el.removeEventListener('transitionend', te); fertig(); });
      } else {
        el.classList.remove('is-in', 'vh-w2-screen--leave');
        el.style.top = '';
      }
    });
    ziel.classList.remove('vh-w2-screen--leave');
    ziel.style.top = '';
    ziel.hidden = false;
    if (RM) { ziel.classList.add('is-in'); } else { requestAnimationFrame(function () { ziel.classList.add('is-in'); }); }
    // Review-Fix W3 (MUSS DNA "Fokus scrollt den Hero weg"): kein Fokussprung beim Erstladen
    // (opts.initial) -- der Browser scrollte sonst bei jedem Seitenaufruf sofort unter den Hero.
    // preventScroll verhindert den harten Sprung; ein gezieltes scrollIntoView holt den Screen nur
    // dann in den Viewport, wenn seine Oberkante wirklich ausserhalb liegt (Konzept §6.4).
    if (!opts.initial) {
      var h2 = $('h2', ziel);
      if (h2) {
        try { h2.focus({ preventScroll: true }); } catch (e) { try { h2.focus(); } catch (e2) {} }
        try {
          var vhW2R = ziel.getBoundingClientRect();
          if (vhW2R.top < 0 || vhW2R.top > window.innerHeight * 0.6) { ziel.scrollIntoView({ block: 'start', behavior: RM ? 'auto' : 'smooth' }); }
        } catch (e3) {}
      }
    }
    // Befund D-Fix 20: kein doppelter History-Eintrag/Push fuer denselben Screen; initialer
    // Aufruf ersetzt (replaceState) statt einen zusaetzlichen Eintrag zu pushen.
    if (opts.popstate) {
      aktuellerScreen = screen;
    } else if (opts.initial) {
      verlauf.push(screen);
      try { history.replaceState({ screen: screen }, ''); } catch (e) {}
      aktuellerScreen = screen;
    } else if (screen !== aktuellerScreen) {
      verlauf.push(screen);
      if (screen !== 'berechnung') { try { history.pushState({ screen: screen }, ''); } catch (e) {} }
      aktuellerScreen = screen;
    }
    aktualisierePunktleiste(screen);
  }
  window.addEventListener('popstate', function (e) {
    var ziel = e.state && e.state.screen ? e.state.screen : 'f-anliegen';
    // Befund D-Fix 21: nur Screens akzeptieren, die zum aktuellen Antwortstand passen — sonst
    // kann ein Vorwaerts-Sprung nach "Nochmal von vorn" auf einen Frage-Screen treffen, dessen
    // vorausgesetzte Antwort fehlt (TypeError in der Empfehlungslogik).
    var ergSec = screenEl('ergebnis');
    var erlaubt = pfadReihenfolge().indexOf(ziel) !== -1 || ziel === 'schnellauswahl' || (ziel === 'ergebnis' && ergSec && ergSec.innerHTML !== '');
    gehe_zu(erlaubt ? ziel : 'f-anliegen', { popstate: true });
  });

  function istKapselnOderEgalNaechte() { return antworten.anliegen === 'naechte' && (antworten.form === 'kapseln' || antworten.form === 'egal'); }
  function pfadReihenfolge() {
    if (antworten.anliegen === 'tier') { return ['f-anliegen']; }
    var r = ['f-anliegen', 'f-form'];
    if (istKapselnOderEgalNaechte()) { return r; }
    r.push('f-belastung', 'f-erfahrung');
    if (antworten.anliegen === 'naechte' || antworten.form === 'kapseln') { return r; }
    r.push('f-einstieg');
    return r;
  }
  function aktualisierePunktleiste(aktuell) {
    var bar = $('[data-vh-w2-fortschritt]', app);
    if (!bar) { return; }
    if (antworten.anliegen === 'tier') { bar.innerHTML = ''; return; }
    var r = pfadReihenfolge(), pos = r.indexOf(aktuell);
    if (pos === -1) { return; }
    var html = '';
    r.forEach(function (id, i) { html += '<span class="vh-w2-fortschritt__punkt ' + (i < pos ? 'vh-w2-fortschritt--erledigt' : (i === pos ? 'vh-w2-fortschritt--aktiv' : 'vh-w2-fortschritt--offen')) + '"></span>'; });
    html += '<span class="visually-hidden">Schritt ' + (pos + 1) + ' von ' + r.length + '</span>';
    bar.innerHTML = html;
  }

  function naechsterSchritt(vonId) {
    var voll = ['f-anliegen', 'f-form', 'f-belastung', 'f-erfahrung', 'f-einstieg'];
    var pfad = pfadReihenfolge();
    var idx = voll.indexOf(vonId);
    for (var i = idx + 1; i < voll.length; i++) {
      if (pfad.indexOf(voll[i]) !== -1) {
        // Review-Fix W3 (RECHT "Kicker-Bedeutung"): Kicker/Frage VOR dem Screen-Wechsel setzen
        // (nicht danach) -- eigener Kicker-Wortlaut je Anliegen statt des f-anliegen-Labels, und
        // bei "alltag" faellt "im Alltag" aus der Frage, weil der Kicker dort leer bleibt.
        if (voll[i] === 'f-belastung') {
          var belScreen = screenEl('f-belastung');
          if (belScreen) {
            var k = $('[data-vh-w2-kicker]', belScreen);
            var kt = ANLIEGEN_KICKER[antworten.anliegen] || '';
            if (k) { k.textContent = kt; k.hidden = !kt; }
            var h2b = $('h2', belScreen);
            if (h2b) { h2b.textContent = antworten.anliegen === 'alltag' ? 'Wie stark beeinträchtigt Sie das gerade?' : 'Wie stark beeinträchtigt Sie das gerade im Alltag?'; }
          }
        }
        gehe_zu(voll[i], {});
        return;
      }
    }
    starteBerechnung();
  }
  // Befund D-Fix 16: Klick-Sperre gegen doppelte Ausloesung (z. B. Doppelklick auf die letzte
  // Kachel schedult zwei 120-ms-Timer, die beide naechsterSchritt()/starteBerechnung() rufen
  // wuerden -> rendere() liefe zweimal, die zweite Karten-Verschiebung faende die Karte nicht
  // mehr an ihrem alten Platz).
  var berechnungGestartet = false;
  function starteBerechnung() {
    if (berechnungGestartet) { return; }
    berechnungGestartet = true;
    if (RM) { renderErgebnis(); return; }
    gehe_zu('berechnung', {});
    setTimeout(renderErgebnis, 600);
  }
  function alleHandlesVon(erg) {
    var hs = [];
    if (erg.haupt && erg.haupt.handle) { hs.push(erg.haupt.handle); }
    if (erg.alt && erg.alt.handle) { hs.push(erg.alt.handle); }
    (erg.raster || []).forEach(function (r) { if (r.handle) { hs.push(r.handle); } });
    return hs;
  }
  function zeigeErgebnisFehler() {
    var sec = screenEl('ergebnis');
    if (sec) { kartenZurueck(sec); sec.innerHTML = '<p class="vh-w2-hinweis">' + esc(C.fehler) + '</p>'; }
    gehe_zu('ergebnis', {});
  }
  function renderErgebnis() {
    // Befund D-Fix 21: kompletter Durchlauf abgesichert — ein unerwarteter Fehler (z. B. durch
    // einen inkonsistenten Antwortstand nach popstate) zeigt den Fehlerpfad statt abzubrechen.
    // Befund D-Fix 24: bis zu zwei Pruef-Runden — aendert die frisch gepruefte Verfuegbarkeit
    // das Ergebnis (neue Handles kommen hinzu), werden auch die nachgeprueft.
    try {
      var pruefRunde = function (vorherigeHs, runden) {
        var erg = berechne(antworten, lagerAktuell());
        var hs = alleHandlesVon(erg);
        var neu = hs.some(function (h) { return vorherigeHs.indexOf(h) === -1; });
        return pruefe_lager(hs).then(function () {
          if (neu && runden < 1) { return pruefRunde(hs, runden + 1); }
          return berechne(antworten, lagerAktuell());
        });
      };
      pruefRunde([], 0).then(function (ergebnis) {
        try {
          rendere(ergebnis);
          gehe_zu('ergebnis', {});
          var art = (!ergebnis.haupt || !ergebnis.haupt.handle) ? 'entfaellt' : (ergebnis.typ === 'ein_produkt' ? 'produkt' : ergebnis.typ);
          vh_w2_track('quiz_result', { art: art, handle: ergebnis.haupt ? ergebnis.haupt.handle : null, alt_handle: ergebnis.alt ? ergebnis.alt.handle : null, kaskade: !!ergebnis.kaskade, schritt_nr: schrittNr() });
        } catch (e2) { zeigeErgebnisFehler(); }
        berechnungGestartet = false;
      }).catch(function () { zeigeErgebnisFehler(); berechnungGestartet = false; });
    } catch (e) {
      zeigeErgebnisFehler();
      berechnungGestartet = false;
    }
  }

  function karteHolen(handle) { return document.querySelector('[data-vh-w2-karte="' + handle + '"]'); }
  function verschiebeKarte(handle, ziel, modus) {
    var karte = karteHolen(handle);
    if (!karte || !ziel) { return null; }
    if (modus === 'link') { karte.setAttribute('data-vh-w2-modus', 'link'); karte.classList.add('vh-w2-karte--link'); }
    else { karte.removeAttribute('data-vh-w2-modus'); karte.classList.remove('vh-w2-karte--link'); }
    ziel.appendChild(karte);
    return karte;
  }
  // Befund D-Fix 16: vorgerenderte Karten muessen VOR jedem innerHTML-Reset eines Slots
  // (Schnellauswahl-Slot, Ergebnis-Screen) nach #vh-w2-karten zurueckgefuehrt werden — sonst
  // loescht innerHTML='' sie samt Kaufformular endgueltig aus dem DOM.
  function kartenZurueck(root) {
    if (!root) { return; }
    var container = document.getElementById('vh-w2-karten');
    $$('[data-vh-w2-karte]', root).forEach(function (k) {
      k.removeAttribute('data-vh-w2-modus');
      k.classList.remove('vh-w2-karte--link');
      if (container) { container.appendChild(k); }
    });
  }
  function satzFT() {
    if (antworten.form === 'kapseln') { return C.satzFT.kapseln; }
    if (antworten.traeger === 'hanf') { return C.satzFT.tropfen_hanf; }
    if (antworten.traeger === 'mct') { return C.satzFT.tropfen_mct; }
    return C.satzFT.tropfen_egal;
  }
  // Review-Fix W3 (RECHT "Antwort-Spiegelung"): setzt die Pill nur aus tatsaechlich beantworteten
  // Teilen zusammen (kein fuehrender Trennpunkt, wenn die Erfahrung nie gefragt wurde -- Naechte+
  // Kapseln/-egal) und behauptet bei form==='egal' keinen Form-Teil (der Nutzer sagte "ist mir egal",
  // nicht "Tropfen").
  function pillTeile() {
    var teile = [];
    if (antworten.erfahrung && ERF_LABEL[antworten.erfahrung]) { teile.push(ERF_LABEL[antworten.erfahrung]); }
    if (antworten.form !== 'egal') { teile.push(satzFT()); }
    return teile.join(' · ');
  }
  function begruendungFuer(erg) {
    var p = produkte[erg.haupt.handle] || {};
    if (erg.haupt.familie === 'tier' || erg.haupt.familie === 'sleep' || erg.haupt.familie === 'relief') { return p.begruendung || ''; }
    if (erg.haupt.familie === 'kapseln') { return tpl(C.begrKapseln, { titel: p.titel || 'die CBD-Kapseln' }); }
    var e = C.satzE[antworten.erfahrung] || '';
    // Review-Fix W3 (RECHT): form==='egal' bekommt eine eigene, formfreie Begruendung -- keine
    // Behauptung "... und Tropfen moechten", die der Nutzer nie beantwortet hat.
    if (antworten.form === 'egal') {
      var satzEgal = tpl(C.begrOelEgal, { e: e, stufe: stufeVon(erg.haupt.handle), tr: traegerVon(erg.haupt.handle) === 'mct' ? 'Bio-MCT-Öl' : 'Bio-Hanföl', rolle: p.rolle || '' });
      if (antworten.einstieg === 'testen') { satzEgal += C.testenSatz; }
      return satzEgal;
    }
    var ft = satzFT();
    if (erg.kaskade && erg.hinweise.length && erg.basisStufe) {
      var btr = antworten.traeger === 'mct' ? 'Bio-MCT-Öl' : 'Bio-Hanföl';
      var ntr = traegerVon(erg.haupt.handle) === 'mct' ? 'Bio-MCT-Öl' : 'Bio-Hanföl';
      return tpl(C.begrKask, { e: e, ft: ft, bstufe: erg.basisStufe, btr: btr, nstufe: stufeVon(erg.haupt.handle), ntr: ntr, rolle: p.rolle || '' });
    }
    var satz = tpl(C.begrOel, { e: e, ft: ft, stufe: stufeVon(erg.haupt.handle), tr: traegerVon(erg.haupt.handle) === 'mct' ? 'Bio-MCT-Öl' : 'Bio-Hanföl', rolle: p.rolle || '' });
    if (antworten.einstieg === 'testen') { satz += C.testenSatz; }
    return satz;
  }
  function collectionLinkFuer(anliegen, familie) {
    if (anliegen === 'tier') { return { text: C.ctaTier, url: (produkte[H.pet] || {}).collection_url || '/collections/cbd-pet' }; }
    if (familie === 'kapseln') { return { text: C.ctaKapseln, url: (produkte[H.kapseln] || {}).collection_url || '/collections/cbd-kapseln' }; }
    return { text: C.ctaOel, url: '/collections/cbd-oel' };
  }
  function pflichtHtml(kategorieFormel, tier) {
    var vier = kategorieFormel ? '<p>' + esc(kategorieFormel) + '</p>' : '';
    return '<div class="vh-w2-pflicht"><p>' + esc(C.p1) + '</p><p>' + esc(tier ? C.p2t : C.p2) + '</p><p>' + esc(C.p3) + '</p>' + vier + '</div>';
  }
  function kontaktHtml() {
    var s = esc(C.kontakt);
    s = s.replace('+43 660 35 28 248', '<a href="tel:+436603528248">+43 660 35 28 248</a>');
    s = s.replace('kundenservice@vitalhemp.de', '<a href="mailto:kundenservice@vitalhemp.de">kundenservice@vitalhemp.de</a>');
    return '<p class="vh-w2-kontakt">' + s + '</p>';
  }
  function restHtml(erg, kategorieFormel, tier, link) {
    // Befund WP-P32 W6 (25.09.): C.verzehr und C.p3 sind wortgleich ("Verzehrempfehlung laut
    // Etikett beachten..."), der Satz stand doppelt untereinander (hier + in pflichtHtml()).
    // Gestrichen, C.p3 in der Pflicht-Box bleibt die einzige Stelle.
    var html = '';
    if (erg.amber) { html += '<div class="vh-w2-amber">' + ic('info') + '<p>' + esc(C.amber) + '</p></div>'; }
    html += pflichtHtml(kategorieFormel, tier);
    html += kontaktHtml();
    var btnKlasse = erg.typ === 'auswahl' ? 'vh-btn vh-btn--primary vh-btn--auto' : 'vh-btn vh-btn--secondary vh-btn--auto';
    html += '<div class="vh-w2-aktionen"><a class="' + btnKlasse + '" href="' + esc(link.url) + '" data-vh-w2-ziel="collection">' + esc(link.text) + '</a>' +
      '<a href="#" class="vh-w2-ergebnis__nochmal" data-vh-w2-nochmal>' + esc(C.nochmal) + '</a>' +
      '<a href="#" class="vh-w2-ergebnis__schnell" data-vh-w2-schnell-link>' + esc(C.schnellLink) + '</a></div>';
    return html;
  }
  // Runde-3-Fix (C2.2 #10/#12): r15-Ableitungslogik (sections/vh-h2-jahre.liquid) — Attribution
  // an "·" splitten, Name-Span nur der Name, Badge = Icon + Rest (Default "verifizierte
  // Bestellung"), Initialen 2 Buchstaben (CLAUDE.md §3.3). #12: avgNum>0 schliesst
  // null/undefined/''/0 gleichermassen aus (vorher zeigte avg=null faelschlich "★★★★★ 0,0").
  function zitatHtml(p) {
    if (!p.zitat) { return ''; }
    var raw = p.zitat_name || '';
    var parts = raw.split('·');
    var name = parts[0].replace(/^—\s*/, '').replace(/^\s+|\s+$/g, '');
    var rest = parts.length > 1 ? parts[1].replace(/^\s+|\s+$/g, '') : 'verifizierte Bestellung';
    var np = name.split(/\s+/).filter(function (w) { return w; });
    var initial = esc(((np[0] ? np[0].charAt(0) : '') + (np[1] ? np[1].charAt(0) : '')).toUpperCase());
    var badge = name ? '<span class="vh-w2-zitat__badge">' + ic('check-circle') + esc(rest) + '</span>' : '';
    var avgNum = Number(p.avg);
    var pill = (p.avg !== null && p.avg !== undefined && p.avg !== '' && isFinite(avgNum) && avgNum > 0) ? '<span class="vh-w2-pill">★★★★★ ' + avgNum.toFixed(1).replace('.', ',') + '</span>' : '';
    // Review-Fix W3 (DNA "Zitat-Markup"): figure/blockquote/figcaption 1:1 wie r15
    // (vh-h2-jahre.liquid), Anfuehrungszeichen-Mark und Initialen-Avatar mit aria-hidden -- ein
    // Screenreader liest sonst "Anfuehrungszeichen unten ... Initialen" mit vor.
    return '<div class="vh-w2-zitat__stage"><figure class="vh-w2-zitat__karte"><span class="vh-w2-zitat__mark" aria-hidden="true">„</span><blockquote><p class="vh-w2-zitat__text">„' + esc(p.zitat) + '“</p></blockquote>' +
      '<figcaption class="vh-w2-zitat__wer"><span class="vh-w2-zitat__avatar" aria-hidden="true">' + initial + '</span><span class="vh-w2-zitat__name">' + esc(name) + '</span>' + badge + '</figcaption>' + pill + '</figure></div>';
  }

  // Runde-3-Fix (C2.2 #11): Papier-Karte + Pin standen fertig in vh-w2.css, rendere() wickelte
  // den Inhalt nie hinein. Pin als Kind der Karte (position:absolute braucht position:relative).
  function ergebnisWrap(inner) {
    return '<div class="vh-w2-ergebnis__karte"><span class="vh-w2-ergebnis__pin" aria-hidden="true"></span>' + inner + '</div>';
  }
  function rendere(erg) {
    var sec = screenEl('ergebnis');
    if (!sec) { return; }
    // Befund D-Fix 16: vorgerenderte Karten IMMER zurueckfuehren, bevor dieser Screen per
    // innerHTML neu gefuellt wird — sonst reisst der naechste Reset die gerade gezeigte
    // Karte (mit Kaufformular) endgueltig aus dem DOM.
    kartenZurueck(sec);
    var html = '<h2 class="vh-w2-ergebnis__h2" tabindex="-1">' + esc(C.ergebnisH2) + '</h2>';

    if (erg.typ === 'tier') {
      var pT = produkte[H.pet] || {};
      html += '<div class="vh-w2-ergebnis__pills"></div><p class="vh-w2-ergebnis__begruendung">' + esc(pT.begruendung || '') + '</p><div class="vh-w2-ergebnis__karten"><div class="vh-w2-ergebnis__haupt" data-slot="haupt"></div></div>';
      html += zitatHtml(pT);
      html += restHtml(erg, pT.kategorie_formel, true, collectionLinkFuer('tier'));
      sec.innerHTML = ergebnisWrap(html);
      var slotT = $('[data-slot="haupt"]', sec);
      if (!verschiebeKarte(H.pet, slotT, 'kauf')) { slotT.appendChild(document.createTextNode(H.pet)); }
      return;
    }

    // Befund D-Fix 25: erg.haupt.handle kann null sein (beide Kaskaden ausgeschoepft,
    // art:'entfaellt') — dann keinen Handle als Text ausgeben, sondern auf die Collection
    // verweisen, ohne Kaufformular.
    if (!erg.haupt || !erg.haupt.handle) {
      var linkE = collectionLinkFuer(antworten.anliegen, erg.haupt ? erg.haupt.familie : null);
      html += '<p class="vh-w2-ergebnis__begruendung">' + esc(C.entfaellt) + '</p>';
      // Review-Fix W3 (RECHT): auch die Variante "entfaellt" (alles ausverkauft) braucht die
      // Pflichtsaetze 1-3 und die Kontaktzeile (Konzept §7.3 "auf jeder Ergebnisvariante").
      html += pflichtHtml(null, false);
      html += kontaktHtml();
      html += '<div class="vh-w2-aktionen"><a class="vh-btn vh-btn--primary vh-btn--auto" href="' + esc(linkE.url) + '" data-vh-w2-ziel="collection">' + esc(linkE.text) + '</a>' +
        '<a href="#" class="vh-w2-ergebnis__nochmal" data-vh-w2-nochmal>' + esc(C.nochmal) + '</a></div>';
      sec.innerHTML = ergebnisWrap(html);
      return;
    }

    if (erg.typ === 'auswahl') {
      var stA = erg.raster[0] ? (stufeVon(erg.raster[0].handle) || 15) : 15;
      // Befund D-Fix 10: Pflichtsatz 4 (Kategorie-Formel) darf auf keiner Ergebnisvariante
      // fehlen — im Auswahl-Layout die Formeln aller gezeigten Raster-Produkte deduplizieren.
      var kf = [];
      erg.raster.forEach(function (r) {
        var f = (produkte[r.handle] || {}).kategorie_formel;
        if (f && kf.indexOf(f) === -1) { kf.push(f); }
      });
      // Review-Fix W3 (CODE/MUSS Befund "10-%-Kapsel"): Kapseln gibt es nur mit 15 % -- der Zusatz
      // "und dazu die CBD-Kapseln 15 %" erscheint deshalb nur, wenn die gezeigte Stufe 15 ist.
      var vhW2KapselnTeil = stA === 15 ? C.auswahlKapselnTeil : '';
      html += '<p class="vh-w2-ergebnis__auswahl-h2">' + esc(C.auswahlH2) + '</p><p class="vh-w2-ergebnis__begruendung">' + esc(tpl(C.auswahlSatz, { stufe: stA, kapseln_teil: vhW2KapselnTeil })) + '</p><div class="vh-w2-ergebnis__raster" data-slot="raster"></div>';
      html += restHtml(erg, kf.join(' '), false, collectionLinkFuer(antworten.anliegen, null));
      sec.innerHTML = ergebnisWrap(html);
      var raster = $('[data-slot="raster"]', sec);
      erg.raster.forEach(function (r) { if (r.handle && !verschiebeKarte(r.handle, raster, 'link')) { raster.appendChild(document.createTextNode(r.handle)); } });
      return;
    }

    var vhW2PillTxt = pillTeile();
    if (vhW2PillTxt) { html += '<div class="vh-w2-ergebnis__pills"><span class="vh-w2-pill">' + esc(vhW2PillTxt) + '</span></div>'; }
    html += '<p class="vh-w2-ergebnis__begruendung">' + esc(begruendungFuer(erg)) + '</p>';
    html += '<div class="vh-w2-ergebnis__karten"><div class="vh-w2-ergebnis__haupt" data-slot="haupt"></div>';
    if (erg.alt && erg.alt.handle) { html += '<div class="vh-w2-ergebnis__alt" data-slot="alt"><p class="vh-w2-ergebnis__alt-kicker">' + esc(C.kickerAlt) + '</p></div>'; }
    html += '</div>';
    var pHaupt = produkte[erg.haupt.handle] || {};
    html += zitatHtml(pHaupt);
    html += restHtml(erg, pHaupt.kategorie_formel, false, collectionLinkFuer(antworten.anliegen, erg.haupt.familie));
    sec.innerHTML = ergebnisWrap(html);
    var slotH = $('[data-slot="haupt"]', sec);
    if (!verschiebeKarte(erg.haupt.handle, slotH, 'kauf')) { slotH.appendChild(document.createTextNode(erg.haupt.handle)); }
    if (erg.alt && erg.alt.handle) {
      var slotA = $('[data-slot="alt"]', sec);
      if (!verschiebeKarte(erg.alt.handle, slotA, 'link')) { slotA.appendChild(document.createTextNode(erg.alt.handle)); }
    }
    // Befund D-Fix 22: kein Listener mehr je Render (Karten werden verschoben, nie geklont —
    // ein pro-Render-Listener bindet sich bei jedem erneuten Rendern zusaetzlich). Ein
    // einziger, einmalig gebundener delegierter Klick-Handler uebernimmt das (siehe unten,
    // im zentralen document-Click-Handler, ueber app.contains(karteEl)).
  }

  function zuruecksetzen(keinGehe) {
    var container = document.getElementById('vh-w2-karten');
    $$('[data-vh-w2-karte]').forEach(function (k) { k.removeAttribute('data-vh-w2-modus'); k.classList.remove('vh-w2-karte--link'); if (container) { container.appendChild(k); } });
    // Review-Fix W3 (SOLL CODE "Ergebnis nach Reset noch abrufbar"): den Ergebnis-Screen leeren --
    // sonst erlaubt der popstate-Handler (der auf innerHTML !== '' prueft) nach "Nochmal von vorn"
    // weiterhin einen Sprung auf "ergebnis", obwohl keine Karte mehr darin steht.
    var vhW2ErgS = screenEl('ergebnis');
    if (vhW2ErgS) { vhW2ErgS.innerHTML = ''; }
    antworten = {}; verlauf = []; berechnungGestartet = false; gestartet = false;
    // Review-Fix W3 (SOLL CODE "Schnellauswahl-Chips werden mitzurueckgesetzt"): nur die
    // Frage-Screens zuruecksetzen -- die statische Schnellauswahl fuehrt ihren eigenen Zustand
    // (initSchnellauswahl()) und darf hier nicht auf "nichts ausgewaehlt" fallen.
    $$('.vh-w2-screen:not([data-vh-w2-screen="schnellauswahl"]) [role="radio"]', app).forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
    $$('[data-vh-w2-traeger-block]', app).forEach(function (b) { b.hidden = true; b.style.height = ''; });
    $$('.vh-w2-frage__weiter', app).forEach(function (b) { b.disabled = true; });
    // Befund D-Fix 33: Slider komplett auf den Neutralzustand zuruecksetzen (--fill, Wort,
    // aria-valuetext) — vorher blieb die zuletzt eingestellte Fuellung/Beschriftung stehen.
    $$('.vh-w2-slider__input', app).forEach(function (i) {
      i.value = '5';
      i.style.removeProperty('--fill');
      var wrap = i.closest('.vh-w2-slider');
      if (wrap) {
        wrap.classList.add('vh-w2-slider--unberuehrt');
        var wortEl = $('.vh-w2-slider__wort', wrap); if (wortEl) { wortEl.textContent = ''; }
      }
      var sliderScreen = null;
      VH_W2_FRAGEN.screens.forEach(function (s) { if (s.typ === 's') { sliderScreen = s; } });
      i.setAttribute('aria-valuetext', sliderScreen ? sliderScreen.unberuehrt : '');
    });
    // Befund D-Fix 20: kein Zwischen-Push — der (einzige) Ruf hier oder in den Aufrufern
    // erzeugt den passenden History-Eintrag.
    if (!keinGehe) { gehe_zu('f-anliegen', {}); }
  }

  // ---- Schnellauswahl (statische Chips aus Liquid) ----
  function initSchnellauswahl() {
    var sec = screenEl('schnellauswahl') || $('[data-vh-w2-screen="schnellauswahl"]');
    if (!sec) { return; }
    var state = { form: 'tropfen', stufe: '10', traeger: 'hanf' }, geoeffnet = false;
    var slot = $('[data-vh-w2-schnell-slot]', sec);
    if (!slot) { slot = document.createElement('div'); slot.setAttribute('data-vh-w2-schnell-slot', ''); sec.appendChild(slot); }
    var katEl = $('[data-vh-w2-schnell-kategorie]', sec);
    function setKategorie(handle) { if (katEl) { katEl.textContent = handle ? ((produkte[handle] || {}).kategorie_formel || '') : ''; } }
    // Review-Fix W3 (SOLL CODE "Chips ohne Auswahl"): den JS-Standardzustand beim Aufbau sichtbar
    // auf die Chips uebertragen -- vorher zeigte der Slot sofort eine Karte, ohne dass irgendein
    // Chip als ausgewaehlt markiert war (weder fuer sehende Nutzer noch fuer Screenreader).
    $$('[data-vh-w2-chip]', sec).forEach(function (c) {
      var r0 = closest(c, '[data-vh-w2-reihe]');
      var rn0 = r0 ? r0.getAttribute('data-vh-w2-reihe') : null;
      c.setAttribute('aria-checked', (rn0 && state[rn0] === c.getAttribute('data-wert')) ? 'true' : 'false');
    });
    function kandidatenVon() {
      if (state.form === 'kapseln') { return [H.kapseln]; }
      var stufeNr = parseInt(state.stufe, 10);
      var vorab = resolveOel(stufeNr, state.traeger, lagerAktuell());
      var hs = vorab.handle ? [vorab.handle] : [];
      if (vorab.art === 'explizit') { hs.push(state.traeger === 'hanf' ? mh(stufeNr) : hh(stufeNr)); }
      return hs;
    }
    // Befund D-Fix 23: vor dem Rendern das Lager je Kandidat nachpruefen (nicht nur den beim
    // Seitenaufbau gerenderten, bis zu 15 Min. gecachten Wert verwenden).
    // Review-Fix W3 (RECHT "stille Vorauswahl"): trackErgebnis (Default true) laesst das erste,
    // unberuehrte Rendern beim blossen Oeffnen (oeffneSchnellauswahl()) OHNE quiz_result-Event
    // laufen -- FAQ 4 verspricht, dass nur gezaehlt wird, "welches Produkt am Ende angezeigt wird",
    // nicht ein Default, den niemand ausgewaehlt hat. Ein echter Chip-Tap ruft weiterhin ohne
    // Parameter auf und trackt wie bisher.
    function aktualisiere(trackErgebnis) {
      if (trackErgebnis === undefined) { trackErgebnis = true; }
      pruefe_lager(kandidatenVon()).then(function () {
        var lager = lagerAktuell(), handle;
        kartenZurueck(slot);
        slot.innerHTML = '';
        if (state.form === 'kapseln') { handle = H.kapseln; }
        else {
          var stufeNr = parseInt(state.stufe, 10);
          var r = resolveOel(stufeNr, state.traeger, lager);
          if (r.kaskade && r.art === 'explizit') {
            // Review-Fix W3 (MUSS CODE "24 % + Bio-MCT-Oel"): r.hinweis kommt bereits fertig aus
            // resolveOel() (mit dem korrekten Original-Traeger/-Stufe) -- der zuvor hier neu
            // gebaute Text nahm faelschlich IMMER den aktuellen state.traeger/stufeNr, auch wenn
            // die Kaskade (z. B. durch den 24-%-Guard unten) laengst etwas anderes aufgeloest hat.
            slot.innerHTML = '<p class="vh-w2-hinweis-kaskade">' + esc(r.hinweis) + '</p>';
            if (!verschiebeKarte(r.handle, slot, 'link')) { slot.appendChild(document.createTextNode(r.handle)); }
            var zwOrig = state.traeger === 'hanf' ? mh(stufeNr) : hh(stufeNr);
            // Review-Fix W3 (MUSS CODE): nur anhaengen, wenn es nicht dieselbe Karte ist, die schon
            // oben steht (sonst erscheint dieselbe Karte zweimal im Slot).
            if (zwOrig !== r.handle && verf(zwOrig, lager)) { if (!verschiebeKarte(zwOrig, slot, 'link')) { slot.appendChild(document.createTextNode(zwOrig)); } }
            setKategorie(r.handle);
            if (trackErgebnis) { vh_w2_track('quiz_result', { art: 'schnell', handle: r.handle, alt_handle: zwOrig, kaskade: true, schritt_nr: 0 }); }
            return;
          }
          handle = r.handle;
        }
        // Befund D-Fix 25: kein lieferbarer Handle (art:'entfaellt') -> Link auf die
        // Oel-Collection statt "null" als Text in den Slot zu schreiben.
        if (!handle) {
          var celUrl = (produkte[H.p10] || {}).collection_url || '/collections/cbd-oel';
          slot.innerHTML = '<p class="vh-w2-hinweis-kaskade">' + esc(C.entfaellt) + '</p><div class="vh-w2-aktionen"><a class="vh-btn vh-btn--primary vh-btn--auto" href="' + esc(celUrl) + '">' + esc(C.ctaOel) + '</a></div>';
          setKategorie(null);
          if (trackErgebnis) { vh_w2_track('quiz_result', { art: 'entfaellt', handle: null, alt_handle: null, kaskade: true, schritt_nr: 0 }); }
          return;
        }
        if (!verschiebeKarte(handle, slot, 'kauf')) { slot.appendChild(document.createTextNode(handle)); }
        setKategorie(handle);
        if (trackErgebnis) { vh_w2_track('quiz_result', { art: 'schnell', handle: handle, alt_handle: null, kaskade: false, schritt_nr: 0 }); }
      });
    }
    // Review-Fix W3 (SOLL CODE "oeffneSchnellauswahl"): einzige Stelle, die die Schnellauswahl
    // "oeffnet" -- rendert immer neu (auch bei jedem Wiederoeffnen) und trackt quiz_quick_start nur
    // beim allerersten Mal. Ueber vhW2OeffneSchnell auch von aussen (Ergebnis-Link) aufrufbar.
    function oeffneSchnellauswahl() {
      if (!geoeffnet) { geoeffnet = true; vh_w2_track('quiz_quick_start', { einstieg: 'schnell' }); }
      aktualisiere(false);
    }
    vhW2OeffneSchnell = oeffneSchnellauswahl;
    sec.addEventListener('click', function (e) {
      var chip = closest(e.target, '[data-vh-w2-chip]');
      if (!chip) { return; }
      var reihe = closest(chip, '[data-vh-w2-reihe]');
      if (!reihe) { return; }
      var reiheName = reihe.getAttribute('data-vh-w2-reihe'), wert = chip.getAttribute('data-wert');
      state[reiheName] = wert;
      $$('[data-vh-w2-chip]', reihe).forEach(function (c) { c.setAttribute('aria-checked', c === chip ? 'true' : 'false'); });
      var stufeReihe = $('[data-vh-w2-reihe="stufe"]', sec), traegerReihe = $('[data-vh-w2-reihe="traeger"]', sec);
      if (reiheName === 'form') { if (stufeReihe) { stufeReihe.hidden = wert === 'kapseln'; } if (traegerReihe) { traegerReihe.hidden = wert === 'kapseln' || state.stufe === '24'; } }
      // Review-Fix W3 (MUSS CODE "24 % + Bio-MCT-Oel"): 24 % gibt es nur in Bio-Hanfoel. Waehlt
      // jemand zuerst MCT und dann 24 %, erzwingt das die Traeger-Chips auf Bio-Hanfoel zurueck und
      // blendet die Traeger-Reihe aus -- vorher blieb state.traeger="mct" haengen, resolveOel(24,
      // 'mct') fand keine Variante und behauptete faelschlich "24 % in Bio-MCT-Oel ist gerade nicht
      // lieferbar", obwohl es diese Variante nie gab.
      if (reiheName === 'stufe') {
        if (wert === '24') {
          state.traeger = 'hanf';
          if (traegerReihe) { $$('[data-vh-w2-chip]', traegerReihe).forEach(function (c) { c.setAttribute('aria-checked', c.getAttribute('data-wert') === 'hanf' ? 'true' : 'false'); }); }
        }
        if (traegerReihe) { traegerReihe.hidden = wert === '24' || state.form === 'kapseln'; }
      }
      aktualisiere();
    });
    document.addEventListener('click', function (e) {
      var goBtn = closest(e.target, '[data-vh-w2-go="schnellauswahl"]');
      if (!goBtn) { return; }
      e.preventDefault();
      gehe_zu('schnellauswahl', {});
      oeffneSchnellauswahl();
    });
    // Befund D-Fix 33: kein eigener Rueckweg-Handler mehr — die reale Sektion verlinkt den
    // Rueckweg ueber data-vh-w2-go="f-anliegen" (vh-w2-quiz.liquid), das der zentrale,
    // delegierte [data-vh-w2-go]-Handler unten bereits abdeckt (toter Code entfernt, Budget).
  }

  // ---- Hero-Video (Muster vh-h2.js, eigener Namensraum vh-w2) ----
  function initHeroVideo() {
    var video = document.querySelector('[data-vh-w2-video]');
    if (!video) { return; }
    var portrait = false; try { portrait = window.matchMedia && window.matchMedia('(max-width: 699px)').matches; } catch (e) {}
    var poster = video.getAttribute(portrait ? 'data-vh-w2-poster-portrait' : 'data-vh-w2-poster-wide');
    if (poster) { video.setAttribute('poster', poster); }
    function attach() {
      // Kein Pause-Knopf mehr (Inhaber 30.09.2026). Unter reduced-motion/saveData bleibt nur
      // das Poster stehen — ohne sichtbaren Knopf, das Video wird einfach nicht gestartet.
      if (RM || SD) { video.removeAttribute('autoplay'); video.pause(); return; }
      var mp4 = video.getAttribute(portrait ? 'data-vh-w2-src-portrait-mp4' : 'data-vh-w2-src-wide-mp4');
      var webm = video.getAttribute(portrait ? 'data-vh-w2-src-portrait-webm' : 'data-vh-w2-src-wide-webm');
      if (webm) { var s1 = document.createElement('source'); s1.src = webm; s1.type = 'video/webm'; video.appendChild(s1); }
      if (mp4) { var s2 = document.createElement('source'); s2.src = mp4; s2.type = 'video/mp4'; video.appendChild(s2); }
      if (webm || mp4) { video.load(); }
    }
    if (document.readyState === 'complete') { attach(); } else { window.addEventListener('load', attach); }
  }

  // ---- Delegierte Klicks/Tastatur für Kacheln, Chips, Slider, Zurück ----
  function waehleKachel(feld, wert, group) {
    antworten[feld] = wert;
    $$('[role="radio"]', group).forEach(function (b) { var on = b.getAttribute('data-wert') === wert; b.setAttribute('aria-checked', on ? 'true' : 'false'); b.setAttribute('tabindex', on ? '0' : '-1'); });
  }
  document.addEventListener('click', function (e) {
    var back = closest(e.target, '[data-vh-w2-zurueck]');
    if (back) { e.preventDefault(); history.back(); return; }

    // Befund D-Fix 22: einmalig delegierter Tracking-Handler fuer Produktkarten-Klicks — ersetzt
    // die pro-Render gebundenen Listener aus rendere() (Doppelbindung bei wiederholtem Rendern,
    // falscher Handle bei der Alt-Karte). Handle kommt von der Karte selbst, nicht aus einer
    // geschlossenen erg-Variable.
    var karteEl = app ? closest(e.target, '[data-vh-w2-karte]') : null;
    if (karteEl && app.contains(karteEl)) {
      var karteHandle = karteEl.getAttribute('data-vh-w2-karte');
      if (closest(e.target, '[data-js-product-add-to-cart]')) { vh_w2_track('quiz_click_product', { handle: karteHandle, ziel: 'cart' }); }
      else if (closest(e.target, 'a[href*="/products/"]')) { vh_w2_track('quiz_click_product', { handle: karteHandle, ziel: 'pdp' }); }
    }

    var chip = closest(e.target, '.vh-w2-chip[role="radio"]');
    if (chip && closest(chip, '[data-vh-w2-traeger-block]')) {
      var group0 = closest(chip, '[role="radiogroup"]');
      waehleKachel('traeger', chip.getAttribute('data-wert'), group0);
      // Befund D-Fix 11: frage_id bleibt der Screen-Name (f-form) — sie darf nicht kodieren,
      // WAS geantwortet wurde (FAQ 4: "welche Schritte genutzt wurden", nicht die Antwort).
      vh_w2_track('quiz_step', { frage_id: 'f-form', richtung: 'vor', schritt_nr: schrittNr() });
      // Runde-3-Fix (C2.2 #9): unter RM sofort weiterschalten statt 120ms-Timer (Konzept §6.2).
      if (RM) { naechsterSchritt('f-form'); } else { setTimeout(function () { naechsterSchritt('f-form'); }, 120); }
      return;
    }

    var kachel = closest(e.target, '.vh-w2-kachel[role="radio"]');
    if (kachel) {
      var group = closest(kachel, '[role="radiogroup"]');
      var feld = group.getAttribute('data-feld');
      var screenSec = closest(kachel, '.vh-w2-screen');
      var screenId = screenSec.getAttribute('data-vh-w2-screen');
      var wert = kachel.getAttribute('data-wert');
      waehleKachel(feld, wert, group);
      // Befund D-Fix 28: einmal pro Durchlauf, nicht an die (durch §20-Fix nun praezisere)
      // Verlaufslaenge gekoppelt — der primaere Hero-CTA haette sonst nie quiz_start gefeuert.
      if (screenId === 'f-anliegen' && !gestartet) { gestartet = true; vh_w2_track('quiz_start', { einstieg: 'gefuehrt' }); }
      if (screenId === 'f-form') {
        var block = $('[data-vh-w2-traeger-block]', screenSec);
        // Review-Fix W3 (RECHT): im Gelenke-Ast fragt die Seite nicht nach dem Traegeroel, sobald
        // Relief lieferbar ist (Relief kommt nur in Bio-MCT-Oel) -- sonst zeigt die Pill spaeter
        // "Tropfen in Bio-Hanfoel" ueber einer MCT-Karte (derselbe Ausnahme-Ast wie "naechte").
        var vhW2TraegerUnterdruecken = antworten.anliegen === 'naechte' || (antworten.anliegen === 'gelenke' && verf(H.relief, lagerAktuell()));
        if (wert === 'tropfen' && block && !vhW2TraegerUnterdruecken) {
          // Befund D-Fix 33: erst 0, dann (per rAF) die Zielhoehe setzen — sonst hat der
          // Browser beim Aufdecken keinen Startwert zum Uebergang und die Hoehen-Transition
          // (220ms) laeuft faktisch nie sichtbar ab. Kein Timer (200-ms-Test bleibt gruen).
          block.hidden = false;
          block.style.height = '0px';
          var zielHoehe = block.scrollHeight;
          if (RM) { block.style.height = zielHoehe + 'px'; } else { requestAnimationFrame(function () { block.style.height = zielHoehe + 'px'; }); }
          return;
        }
        if (block) { block.hidden = true; block.style.height = ''; }
        antworten.traeger = null;
      }
      // Runde-3-Fix (C2.2 #9): dieselbe RM-Weiche wie beim Träger-Chip oben.
      if (RM) {
        vh_w2_track('quiz_step', { frage_id: screenId, richtung: 'vor', schritt_nr: schrittNr() });
        naechsterSchritt(screenId);
      } else {
        setTimeout(function () { vh_w2_track('quiz_step', { frage_id: screenId, richtung: 'vor', schritt_nr: schrittNr() }); naechsterSchritt(screenId); }, 120);
      }
      return;
    }

    var weiter = closest(e.target, '[data-vh-w2-weiter]');
    if (weiter && !weiter.disabled) {
      var s = closest(weiter, '.vh-w2-screen');
      vh_w2_track('quiz_step', { frage_id: s.getAttribute('data-vh-w2-screen'), richtung: 'vor', schritt_nr: schrittNr() });
      naechsterSchritt(s.getAttribute('data-vh-w2-screen'));
      return;
    }

    var nochmal = closest(e.target, '[data-vh-w2-nochmal]');
    if (nochmal) { e.preventDefault(); zuruecksetzen(); return; }
    var schnellLink = closest(e.target, '[data-vh-w2-schnell-link]');
    // Befund D-Fix 20: nur EIN History-Eintrag fuer diese Aktion (Reset ohne eigenen Push,
    // dann ein Push auf "schnellauswahl") statt zwei.
    // Review-Fix W3 (SOLL CODE "Direkt zur Schnellauswahl ohne aktualisiere()"): der Rueckweg aus
    // dem Ergebnis rief die Schnellauswahl bisher ohne aktualisiere() auf -- der Slot blieb leer.
    if (schnellLink) { e.preventDefault(); zuruecksetzen(true); gehe_zu('schnellauswahl', {}); if (vhW2OeffneSchnell) { vhW2OeffneSchnell(); } return; }
    var collLink = closest(e.target, '[data-vh-w2-ziel="collection"]');
    if (collLink) { vh_w2_track('quiz_click_product', { handle: null, ziel: 'collection' }); return; }

    var go = closest(e.target, '[data-vh-w2-go]');
    if (go && go.getAttribute('data-vh-w2-go') !== 'schnellauswahl') {
      e.preventDefault();
      var ziel = go.getAttribute('data-vh-w2-go');
      gehe_zu(ziel, {});
      var zEl = screenEl(ziel);
      if (zEl && !RM) { try { zEl.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e2) {} }
    }
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-vh-w2-slider]')) { return; }
    var input = e.target;
    antworten.belastung = parseInt(input.value, 10);
    var w = wortB(antworten.belastung);
    var wrap = closest(input, '.vh-w2-slider');
    wrap.classList.remove('vh-w2-slider--unberuehrt');
    var out = $('.vh-w2-slider__wort', wrap); if (out) { out.textContent = w; }
    input.setAttribute('aria-valuetext', w);
    // Befund D-Fix 5: --fill (Track-Fuellung) wurde nirgends gesetzt — Track blieb immer bei 50%.
    input.style.setProperty('--fill', ((antworten.belastung - 1) / 9 * 100) + '%');
    var s = closest(input, '.vh-w2-screen');
    var weiterBtn = $('.vh-w2-frage__weiter', s); if (weiterBtn) { weiterBtn.disabled = false; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') { return; }
    var t = e.target;
    if (!t.matches || !t.matches('[role="radio"]')) { return; }
    var group = closest(t, '[role="radiogroup"]');
    if (!group) { return; }
    var items = $$('[role="radio"]', group);
    var idx = items.indexOf(t);
    if (idx === -1) { return; }
    e.preventDefault();
    var dir = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
    var n = items[(idx + dir + items.length) % items.length];
    items.forEach(function (i) { i.setAttribute('tabindex', '-1'); });
    n.setAttribute('tabindex', '0'); n.focus();
  });

  // ---- Init ----
  function ladeDaten() {
    var scriptEl = document.getElementById('vh-w2-daten');
    if (!scriptEl) { return null; }
    try {
      // Review-Fix W3 (MUSS DNA/CODE "arr.forEach is not a function"): sections/vh-w2-quiz.liquid
      // liefert ein Objekt {"produkte":[...]}, nicht ein nacktes Array -- der Liquid-Vertrag
      // (Konzept/technik-bauplan §2) aendert sich nicht, das JS liest jetzt beide Formen.
      var raw = JSON.parse(scriptEl.textContent || scriptEl.innerText || '[]');
      var arr = Array.isArray(raw) ? raw : (raw && Array.isArray(raw.produkte) ? raw.produkte : null);
      if (!arr || !arr.length) { return null; }
      var map = {};
      arr.forEach(function (p) { map[p.handle] = p; lagerServer[p.handle] = p.verfuegbar !== false; });
      return map;
    } catch (e) { try { console.error('vh-w2: Produktdaten', e); } catch (e2) {} return null; }
  }
  // Befund D-Fix 30: ein Init-Fehler darf die statische Seite (Schnellauswahl, 12 vorgerenderte
  // Karten) nicht zerstoeren — Hinweis ergaenzen statt app.innerHTML zu ueberschreiben, und die
  // Schnellauswahl sichtbar lassen, auch wenn buildScreens()/initSchnellauswahl() nicht liefen.
  function zeigeInitFehler() {
    if (!app) { return; }
    try { app.insertAdjacentHTML('afterbegin', '<p class="vh-w2-hinweis">' + esc(C.fehler) + '</p>'); } catch (e) {}
    var schnell = $('[data-vh-w2-screen="schnellauswahl"]', app);
    if (schnell) { schnell.hidden = false; schnell.classList.add('is-in'); }
  }
  function init() {
    app = document.getElementById('vh-w2-app');
    if (!app) { return; }
    try {
      initHeroVideo();
      var daten = ladeDaten();
      if (!daten) { throw new Error('vh-w2: keine Produktdaten'); }
      produkte = daten;
      buildScreens();
      initSchnellauswahl();
      // Review-Fix W3 (SOLL CODE "vh-h-js unabhaengig von vh-w2.js"): vh-h.js setzt "vh-h-js"
      // unabhaengig davon, ob vh-w2.js erfolgreich startet -- die Opacity-0-Regel der Screens hing
      // bisher an "vh-h-js" und liess die statische Schnellauswahl unsichtbar, wenn vh-w2.js nicht
      // lief (Syntaxfehler, Blocker). Die eigene Klasse "vh-w2-js" wird erst HIER gesetzt, also nur
      // nach erfolgreichem buildScreens()/initSchnellauswahl(); vh-w2.css bindet die Screen-Regeln
      // jetzt an "vh-w2-js" statt an "vh-h-js".
      document.documentElement.classList.add('vh-h-js', 'vh-w2-js');
      gehe_zu('f-anliegen', { initial: true });
    } catch (e) {
      zeigeInitFehler();
    }
  }

  window.VH_W2_TEST = {
    berechne: berechne, resolveOel: resolveOel, basisStufe: basisStufe, pruefe_lager: pruefe_lager,
    setBelastungWirkt: function (v) { VH_W2_BELASTUNG_WIRKT = v; }, getBelastungWirkt: function () { return VH_W2_BELASTUNG_WIRKT; },
    H: H, SPERRLISTE: VH_W2_SPERRLISTE, init: init, zuruecksetzen: function () { return zuruecksetzen(); },
    gehe_zu: gehe_zu, getAntworten: function () { return antworten; }, setAntworten: function (a) { antworten = a; },
    setLagerServer: function (o) { lagerServer = o; }, setLagerCache: function (o) { lagerCache = o; }, getLagerCache: function () { return lagerCache; }
  };

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
